"use client";

import { useEffect, useRef } from "react";
import { reconcileAccountLocale } from "@tami/core/intl";

import type { PublicAuthUser } from "@/lib/auth/types";
import { chooseLocale, detectClientLocale } from "@/lib/i18n/client-locale";
import { updateMyLocale } from "@/services/user/update-my-locale.service";

/**
 * Ao entrar, concilia o idioma da conta com o do navegador
 * (`reconcileAccountLocale`): a conta vence, e a escolha feita no app ou no
 * desktop vale aqui; conta sem idioma recebe o do navegador. Uma vez por
 * usuário — aplicar recarrega a página e a próxima leitura já concorda.
 */
export function useAccountLocaleSync(user: PublicAuthUser | null): void {
  const syncedUserId = useRef<string | null>(null);

  useEffect(() => {
    if (!user || syncedUserId.current === user.id) return;
    syncedUserId.current = user.id;
    const device = detectClientLocale(
      document.cookie,
      navigator.languages ?? [navigator.language],
    );
    const sync = reconcileAccountLocale(user.locale, device);
    if (sync.type === "apply") chooseLocale(sync.locale);
    // Melhor esforço: sem gravar, a API manda e-mail no idioma padrão até o
    // próximo login tentar de novo.
    if (sync.type === "save") void updateMyLocale(sync.locale).catch(() => undefined);
  }, [user]);
}
